import request from '@/config/axios'

// 线路增值服务 - 平台模式
export const getValueAddedPage = (params: any) => {
  return request.get({ url: '/scenic/route/value-added/page', params })
}

export const getValueAdded = (id: number) => {
  return request.get({ url: '/scenic/route/value-added/get', params: { id } })
}

export const getValueAddedListByRouteId = (routeId: number) => {
  return request.get({ url: '/scenic/route/value-added/list-by-route', params: { routeId } })
}

export const createValueAdded = (data: any) => {
  return request.post({ url: '/scenic/route/value-added/create', data })
}

export const updateValueAdded = (data: any) => {
  return request.put({ url: '/scenic/route/value-added/update', data })
}

export const deleteValueAdded = (id: number) => {
  return request.delete({ url: '/scenic/route/value-added/delete', params: { id } })
}

export const deleteValueAddedList = (ids: number[]) => {
  return request.delete({ url: '/scenic/route/value-added/delete-list', params: { ids: ids.join(',') } })
}

export const updateValueAddedStatus = (id: number, status: number) => {
  return request.put({ url: '/scenic/route/value-added/update-status', params: { id, status } })
}
